<template>
  <div>
    <!-- <AntigoDashboardInfo class="mb-8" /> -->
    <b-row class="px-4">
      <div
        class="card card-custom bg-light-warning card-stretch gutter-b p-4"
        v-if="certificadoVencidoMsg"
      >
        <p class="mb-0 font-weight-bolder">
          <Warning :size="20" />
          {{ certificadoVencidoMsg }}
          <strong
            ><a
              href="https://wa.me/554935500600?text=Quero saber mais sobre o certificado digital!"
              target="_blank"
            >
              Clique Aqui</a
            ></strong
          >
        </p>
      </div>
    </b-row>
    <b-row class="px-4 blinking-row">
      <div
        class="card card-custom bg-light-danger card-stretch gutter-b p-4"
        v-if="licenca.apresentar_renovacao"
      >
        <p class="mb-0 font-weight-bolder">
          <Warning :size="20" />
          Sua assinatura está prestes a vencer nos próximos dias, realize a sua
          renovação automaticamente:
          <strong>
            <a @click="$router.push({ name: 'assinatura' })">
              Para realizar a renovação agora, clique aqui!
            </a>
          </strong>
        </p>
      </div>
    </b-row>
    <b-row v-if="useCustomDashboard">
      <div class="col-12 d-flex justify-content-center">
        <div class="w-100">
          <div
            v-if="visibleDashboardCards.length"
            class="custom-dashboard-grid"
          >
            <GridLayout
              :layout="displayDashboardLayout"
              @update:layout="onDashboardGridLayoutUpdate"
              :col-num="dashboardGridColumns"
              :row-height="dashboardGridRowHeight"
              :is-draggable="dashboardEditing"
              :is-resizable="false"
              :vertical-compact="true"
              :prevent-collision="false"
              :margin="dashboardGridMargin"
              :use-css-transforms="true"
            >
              <GridItem
                v-for="layoutItem in displayDashboardLayout"
                :key="layoutItem.i"
                :x="layoutItem.x"
                :y="layoutItem.y"
                :w="layoutItem.w"
                :h="layoutItem.h"
                :i="layoutItem.i"
              >
                <div
                  class="dashboard-grid-card"
                  :class="{ 'dashboard-grid-card-editing': dashboardEditing }"
                >
                  <span v-if="dashboardEditing" class="dashboard-drag-handle">
                    Mover
                  </span>
                  <component
                    :is="getDashboardCard(layoutItem.i).component"
                    class="dash-widget h-100"
                    v-bind="getDashboardCardProps(layoutItem.i)"
                    v-on="getDashboardCardListeners(layoutItem.i)"
                  />
                </div>
              </GridItem>
            </GridLayout>
          </div>
          <div v-else class="dashboard-empty-custom">
            Nenhum card configurado para o seu dashboard.
          </div>
        </div>
        <div style="width: 250px" class="d-none ml-8 d-lg-block">
          <div class="dashboard-edit-toolbar mb-4">
            <template v-if="dashboardEditing">
              <b-button
                v-b-tooltip.hover
                title="Salvar layout"
                variant="light-primary"
                class="dashboard-edit-icon"
                @click="saveDashboardLayout"
              >
                <b-icon icon="check2" />
              </b-button>
              <b-button
                v-b-tooltip.hover
                title="Cancelar edição"
                variant="light"
                class="dashboard-edit-icon"
                @click="cancelDashboardEdit"
              >
                <b-icon icon="x" />
              </b-button>
              <b-button
                v-b-tooltip.hover
                title="Restaurar padrão"
                variant="light"
                class="dashboard-edit-icon"
                @click="restoreDefaultDashboardLayout"
              >
                <b-icon icon="arrow-counterclockwise" />
              </b-button>
            </template>
            <b-button
              v-else
              v-b-tooltip.hover
              title="Editar dashboard"
              variant="light"
              class="dashboard-edit-icon"
              @click="startDashboardEdit"
            >
              <b-icon icon="pencil" />
            </b-button>
          </div>
          <Atalhos :editing="dashboardEditing" />
          <CardNovidades
            v-if="pacoteNovidades && isRevendaNuts"
            :pacote="pacoteNovidades"
            @ver-novidades="abrirModalNovidades"
            class="mt-4"
          />
        </div>
        <div class="d-block d-lg-none">
          <div
            v-if="dashboardEditing"
            class="dashboard-edit-toolbar dashboard-edit-toolbar-mobile mb-4"
          >
            <b-button
              v-b-tooltip.hover
              title="Salvar layout"
              variant="light-primary"
              class="dashboard-edit-icon"
              @click="saveDashboardLayout"
            >
              <b-icon icon="check2" />
            </b-button>
            <b-button
              v-b-tooltip.hover
              title="Cancelar edição"
              variant="light"
              class="dashboard-edit-icon"
              @click="cancelDashboardEdit"
            >
              <b-icon icon="x" />
            </b-button>
            <b-button
              v-b-tooltip.hover
              title="Restaurar padrão"
              variant="light"
              class="dashboard-edit-icon"
              @click="restoreDefaultDashboardLayout"
            >
              <b-icon icon="arrow-counterclockwise" />
            </b-button>
          </div>
          <FabAtalhos />
        </div>
      </div>
    </b-row>
    <b-row v-if="!useCustomDashboard">
      <div class="col-12 d-flex justify-content-center">
        <div class="w-100">
          <b-row>
            <div class="col-md-4 mb-8">
              <Totalizador
                class="dash-widget"
                :totais-cadastros="totais_cadastros"
                :loading="loadingTotais"
              />
            </div>
            <div class="col-md-8 mb-8" v-if="userAccessStore.access.financeiro">
              <TotalizadorContas
                class="dash-widget"
                :totaisFinanceiros="totais_financeiros"
                :loading="loadingTotais"
              />
            </div>
          </b-row>
          <b-row v-if="currentUser.admin">
            <div class="col-md-4 mb-8">
              <TicketMedio
                class="dash-widget"
                :ticketMedio="ticketMedio"
                :loading="loadingTicketMedio"
                :periodo="tmPeriodo"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('ticketMedio', $event)"
              />
            </div>
            <div class="col-md-4 mb-8">
              <MargemLucro
                class="dash-widget"
                :margemLucro="margemLucro"
                :periodo="margemPeriodo"
                :loading="loadingMargemLucro"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('margemLucro', $event)"
              />
            </div>
            <div class="col-md-4 mb-8">
              <Vendas
                class="dash-widget"
                :valorVendas="valorVendas"
                :periodo="vendasPeriodo"
                :loading="loadingValorVendas"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('valorVendas', $event)"
              />
            </div>
          </b-row>
          <b-row v-if="currentUser.admin">
            <div class="col-md-4">
              <b-row>
                <div class="col-12 mb-8">
                  <MetaFaturamento :loading="loadingMeta" :dados="metaMensal" />
                </div>
                <div class="col-12 mb-8">
                  <Inadimplencia
                    class="dash-widget"
                    :loading="loadingInadimplencia"
                    :inadimplencia="inadimplencia"
                    :periodo="inadimplenciaPeriodo"
                    :ignore-initial-apply="true"
                    @change-periodo="onPeriodoChange('inadimplencia', $event)"
                  />
                </div>
              </b-row>
            </div>
            <div class="col-md-8">
              <b-row>
                <div class="col-12 col-xxxl-6 mb-8">
                  <RelacaoFinanceira
                    class="dash-widget"
                    :dados="relacaoFinanceira"
                    :periodo="relacaoFinanceiraPeriodo"
                    :loading="loadingRelacaoFinanceira"
                    :ignore-initial-apply="true"
                    @change-periodo="
                      onPeriodoChange('relacaoFinanceira', $event)
                    "
                  />
                </div>
                <div class="col-12 col-xxxl-6 mb-8">
                  <GraficoVendas
                    class="dash-widget"
                    :dados="relacaoVendas"
                    :loading="loadingGraficoVendas"
                    :ignore-initial-apply="true"
                    @change-comparacao="onComparacaoVendas"
                  />
                </div>
              </b-row>
            </div>
          </b-row>
        </div>
        <div style="width: 250px" class="d-none ml-8 d-lg-block">
          <Atalhos />
          <CardNovidades
            v-if="pacoteNovidades && isRevendaNuts"
            :pacote="pacoteNovidades"
            @ver-novidades="abrirModalNovidades"
            class="mt-4"
          />
        </div>
        <div class="d-block d-lg-none">
          <FabAtalhos />
        </div>
      </div>
    </b-row>
    <ModalNovidades
      v-if="isRevendaNuts"
      modal-id="modal-novidades-dashboard"
      :pacote="pacoteNovidades"
      @lido="onNovidadeLida"
      @fechar="modalNovidadesAberto = false"
    />

    <b-row v-if="!useCustomDashboard">
      <div class="col-md-5 col-xxxl-4 mb-8">
        <Aniversariantes
          class="dash-widget h-100"
          :dados="aniversariantes"
          :loading="loadingAniversariantes"
        />
      </div>
      <div class="col-md-6 col-xxxl-4 mb-8" v-if="currentUser.admin">
        <TopProdutosVendidos
          class="dash-widget"
          :dados="produtosMaisVendidos"
          :periodo="produtosPeriodo"
          :loading="loadingTopProdutos"
          :ignore-initial-apply="true"
          @change-periodo="onPeriodoChange('produtosMaisVendidos', $event)"
        />
      </div>
      <div class="col-md-6 col-xxxl-4 mb-8" v-if="currentUser.admin">
        <TopClientes
          class="dash-widget"
          :dados="clientesTop"
          :periodo="clientesPeriodo"
          :loading="loadingMaioresClientes"
          :ignore-initial-apply="true"
          @change-periodo="onPeriodoChange('clientesTop', $event)"
        />
      </div>
    </b-row>
  </div>
</template>

<script>
import Aniversariantes from "../components/Aniversariantes.vue";
// import AntigoDashboardInfo from "../components/AntigoDashboardInfo.vue";
import Atalhos from "../components/Atalhos.vue";
import CaixaAberto from "../components/CaixaAberto.vue";
import FabAtalhos from "../components/FabAtalhos.vue";
import EstoqueCritico from "../components/EstoqueCritico.vue";
import GraficoVendas from "../components/GraficoVendas.vue";
import Inadimplencia from "../components/Inadimplencia.vue";
import MargemLucro from "../components/MargemLucro.vue";
import MetaFaturamento from "../components/MetaFaturamento.vue";
import RelacaoFinanceira from "../components/RelacaoFinanceira.vue";
import TicketMedio from "../components/TicketMedio.vue";
import TopClientes from "../components/TopClientes.vue";
import TopProdutosVendidos from "../components/TopProdutosVendidos.vue";
import Totalizador from "../components/Totalizador.vue";
import TotalizadorContas from "../components/TotalizadorContas.vue";
import Vendas from "../components/Vendas.vue";
import CardNovidades from "../components/CardNovidades.vue";
import ModalNovidades from "../components/ModalNovidades.vue";
import { mapGetters } from "vuex";
import { userAccessStore } from "@/userAccessStore";
import { GridLayout, GridItem } from "vue-grid-layout";
import {
  getDefaultDashboardLayout,
  getEligibleDashboardCards,
  normalizeDashboardLayout,
  sanitizeDashboardCardIds,
} from "../dashboardCards";

export default {
  name: "app-dashboard-v2",
  components: {
    RelacaoFinanceira,
    Vendas,
    TopProdutosVendidos,
    Aniversariantes,
    Totalizador,
    Atalhos,
    CaixaAberto,
    EstoqueCritico,
    GraficoVendas,
    MetaFaturamento,
    TicketMedio,
    Inadimplencia,
    TopClientes,
    MargemLucro,
    FabAtalhos,
    // AntigoDashboardInfo,
    TotalizadorContas,
    CardNovidades,
    ModalNovidades,
    GridLayout,
    GridItem,
  },

  data() {
    const todayISO = () => {
      const d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().slice(0, 10);
    };
    const last7DaysRangeISO = () => {
      const end = new Date(); // hoje
      const start = new Date(); // hoje - 6 dias
      start.setDate(end.getDate() - 6);

      // corrige timezone local
      start.setMinutes(start.getMinutes() - start.getTimezoneOffset());
      end.setMinutes(end.getMinutes() - end.getTimezoneOffset());

      return {
        inicio: start.toISOString().slice(0, 10),
        fim: end.toISOString().slice(0, 10),
      };
    };
    const hoje = todayISO();
    const semana = last7DaysRangeISO();

    return {
      dash: null,
      loadingTotais: false,
      loadingTicketMedio: false,
      loadingMargemLucro: false,
      loadingValorVendas: false,
      loadingInadimplencia: false,
      loadingRelacaoFinanceira: false,
      loadingAniversariantes: false,
      loadingTopProdutos: false,
      loadingMaioresClientes: false,
      loadingGraficoVendas: false,
      loadingMeta: false,
      loadingCaixaAberto: false,
      loadingEstoqueCritico: false,
      error: null,
      cancelSource: null, // evita corrida de requests se filtros mudarem rápido
      totais_cadastros: null,
      totais_financeiros: null,
      ticketMedio: 0,
      margemLucro: {
        margemPercent: 0,
        lucro: 0,
      },
      valorVendas: 0,
      inadimplencia: null,
      relacaoFinanceira: null,
      aniversariantes: null,
      produtosMaisVendidos: null,
      clientesTop: null,
      metaMensal: null,
      caixaAberto: null,
      estoqueCritico: null,
      relacaoVendas: [],
      filtros: { inicio_tm: hoje, fim_tm: hoje },
      tmPeriodo: null,
      margemPeriodo: null,
      vendasPeriodo: null,
      inadimplenciaPeriodo: null,
      relacaoFinanceiraPeriodo: null,
      produtosPeriodo: null,
      clientesPeriodo: null,
      semana: semana,
      userAccessStore,
      certificadoVencidoMsg: "",
      pacoteNovidades: null,
      modalNovidadesAberto: false,
      dashboardEditing: false,
      dashboardLayout: [],
      dashboardLayoutSnapshot: [],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["licenca", "idRevenda"]),
    INDICADORES() {
      return {
        ticketMedio: {
          inicioKey: "inicio_tm",
          fimKey: "fim_tm",
          onlyKey: "only_ticket_medio",
          loadingKey: "loadingTicketMedio",
          stateKey: "ticketMedio",
          periodoKey: "tmPeriodo",
        },
        margemLucro: {
          inicioKey: "inicio_margem",
          fimKey: "fim_margem",
          onlyKey: "only_margem_lucro",
          loadingKey: "loadingMargemLucro",
          stateKey: "margemLucro",
          periodoKey: "margemPeriodo",
        },
        valorVendas: {
          inicioKey: "inicio_vendas",
          fimKey: "fim_vendas",
          onlyKey: "only_vendas",
          loadingKey: "loadingValorVendas",
          stateKey: "valorVendas",
          periodoKey: "vendasPeriodo",
        },
        produtosMaisVendidos: {
          inicioKey: "inicio_produtos",
          fimKey: "fim_produtos",
          onlyKey: "only_produtos",
          loadingKey: "loadingTopProdutos",
          stateKey: "produtosMaisVendidos",
          periodoKey: "produtosPeriodo",
        },
        inadimplencia: {
          inicioKey: "inicio_inadimplencia",
          fimKey: "fim_inadimplencia",
          onlyKey: "only_inadimplencia",
          loadingKey: "loadingInadimplencia",
          stateKey: "inadimplencia",
          periodoKey: "inadimplenciaPeriodo",
        },
        relacaoFinanceira: {
          inicioKey: "inicio_relacao_fina",
          fimKey: "fim_relacao_fina",
          onlyKey: "only_relacao_financeira",
          loadingKey: "loadingRelacaoFinanceira",
          stateKey: "relacaoFinanceira",
          periodoKey: "relacaoFinanceiraPeriodo",
        },
        clientesTop: {
          inicioKey: "inicio_cliente",
          fimKey: "fim_cliente",
          onlyKey: "only_clientes",
          loadingKey: "loadingMaioresClientes",
          stateKey: "clientesTop",
          periodoKey: "clientesPeriodo",
        },
      };
    },
    ...mapGetters(["currentUser"]),
    isRevendaNuts() {
      return this.idRevenda === 1;
    },
    useCustomDashboard() {
      return (
        !!this.currentUser?.admin || !!this.currentUser?.dashboard_habilitado
      );
    },
    eligibleDashboardCards() {
      return getEligibleDashboardCards(
        this.currentUser?.recursos || [],
        this.currentUser || {}
      );
    },
    visibleDashboardCards() {
      if (!this.useCustomDashboard) return [];

      const savedCards = this.currentUser?.dashboard_cards || [];
      const selectedIds =
        this.currentUser?.admin && savedCards.length === 0
          ? this.eligibleDashboardCards.map((card) => card.id)
          : sanitizeDashboardCardIds(savedCards, this.eligibleDashboardCards);

      return this.eligibleDashboardCards.filter((card) =>
        selectedIds.includes(card.id)
      );
    },
    visibleDashboardCardIds() {
      return this.visibleDashboardCards.map((card) => card.id);
    },
    dashboardCardsById() {
      return this.visibleDashboardCards.reduce((cards, card) => {
        cards[card.id] = card;
        return cards;
      }, {});
    },
    dashboardGridColumns() {
      if (this.windowWidth < 768) return 1;
      if (this.windowWidth < 1200) return 6;
      return 12;
    },
    dashboardGridMargin() {
      return this.windowWidth < 768 ? [0, 16] : [24, 24];
    },
    dashboardGridRowHeight() {
      return this.windowWidth < 768 ? 52 : 56;
    },
    displayDashboardLayout() {
      return this.getResponsiveDashboardLayout(
        this.dashboardLayout,
        this.dashboardGridColumns
      );
    },
  },
  async created() {
    this.resetFiltrosDefault();
    this.syncCustomDashboardLayout();
    this.fetchDashboard();
    if (this.idRevenda === 1) this.fetchNovidadesDashboard();

    const response = await this.$http.post("/empresa/validade-certificado", {
      id: this.currentUser.usuario_empresa.id_empresa,
    });
    this.certificadoVencidoMsg = response?.data.mensagem ?? "";
  },
  mounted() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  watch: {
    currentUser: {
      deep: true,
      handler() {
        this.syncCustomDashboardLayout();
      },
    },
  },

  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    cloneDashboardLayout(layout) {
      return JSON.parse(JSON.stringify(layout || []));
    },
    // O layout salvo/editável sempre usa uma grade de 12 colunas. Em telas
    // menores o col-num muda (6 ou 1), mas o vue-grid-layout não reescala
    // sozinho as posições x/w dos itens, então sem essa adaptação os cards
    // ficavam sobrepostos/cortados no mobile. Aqui geramos um layout apenas
    // para exibição, proporcional ao número de colunas atual, sem alterar o
    // layout de 12 colunas armazenado em dashboardLayout.
    getResponsiveDashboardLayout(layout, cols) {
      if (cols >= 12) return layout;

      const sorted = [...(layout || [])].sort(
        (a, b) => a.y - b.y || a.x - b.x
      );

      if (cols === 1) {
        let cursorY = 0;
        return sorted.map((item) => {
          const mapped = { ...item, x: 0, w: 1, y: cursorY };
          cursorY += item.h;
          return mapped;
        });
      }

      const scale = cols / 12;
      return sorted.map((item) => {
        const w = Math.max(1, Math.min(cols, Math.round(item.w * scale)));
        const x = Math.min(cols - w, Math.max(0, Math.round(item.x * scale)));
        return { ...item, x, w };
      });
    },
    onDashboardGridLayoutUpdate(layout) {
      // Ignora atualizações vindas de layouts responsivos adaptados
      // (tablet/mobile) para não corromper o layout de 12 colunas salvo.
      if (this.dashboardGridColumns < 12) return;
      this.dashboardLayout = layout;
    },
    syncCustomDashboardLayout() {
      if (!this.useCustomDashboard) {
        this.dashboardLayout = [];
        this.dashboardLayoutSnapshot = [];
        return;
      }

      this.dashboardLayout = normalizeDashboardLayout(
        this.currentUser?.dashboard_layout || [],
        this.visibleDashboardCards
      );
      this.dashboardLayoutSnapshot = this.cloneDashboardLayout(
        this.dashboardLayout
      );
    },
    getDashboardCard(cardId) {
      return this.dashboardCardsById[cardId] || {};
    },
    getDashboardCardProps(cardId) {
      const common = {
        ignoreInitialApply: true,
      };

      switch (cardId) {
        case "cadastros_resumo":
          return {
            totaisCadastros: this.totais_cadastros,
            loading: this.loadingTotais,
          };
        case "contas_hoje":
          return {
            totaisFinanceiros: this.totais_financeiros,
            loading: this.loadingTotais,
          };
        case "ticket_medio":
          return {
            ...common,
            ticketMedio: this.ticketMedio,
            loading: this.loadingTicketMedio,
            periodo: this.tmPeriodo,
          };
        case "margem_lucro":
          return {
            ...common,
            margemLucro: this.margemLucro,
            loading: this.loadingMargemLucro,
            periodo: this.margemPeriodo,
          };
        case "vendas_periodo":
          return {
            ...common,
            valorVendas: this.valorVendas,
            loading: this.loadingValorVendas,
            periodo: this.vendasPeriodo,
          };
        case "meta_faturamento":
          return {
            dados: this.metaMensal,
            loading: this.loadingMeta,
          };
        case "inadimplencia":
          return {
            ...common,
            inadimplencia: this.inadimplencia,
            loading: this.loadingInadimplencia,
            periodo: this.inadimplenciaPeriodo,
          };
        case "relacao_financeira":
          return {
            ...common,
            dados: this.relacaoFinanceira,
            loading: this.loadingRelacaoFinanceira,
            periodo: this.relacaoFinanceiraPeriodo,
          };
        case "relacao_vendas":
          return {
            ...common,
            dados: this.relacaoVendas,
            loading: this.loadingGraficoVendas,
          };
        case "aniversariantes":
          return {
            dados: this.aniversariantes,
            loading: this.loadingAniversariantes,
          };
        case "produtos_mais_vendidos":
          return {
            ...common,
            dados: this.produtosMaisVendidos,
            periodo: this.produtosPeriodo,
            loading: this.loadingTopProdutos,
          };
        case "maiores_clientes":
          return {
            ...common,
            dados: this.clientesTop,
            periodo: this.clientesPeriodo,
            loading: this.loadingMaioresClientes,
          };
        case "caixa_aberto":
          return {
            dados: this.caixaAberto,
            loading: this.loadingCaixaAberto,
          };
        case "estoque_critico":
          return {
            dados: this.estoqueCritico,
            loading: this.loadingEstoqueCritico,
          };
        default:
          return {};
      }
    },
    getDashboardCardListeners(cardId) {
      const periodoHandlers = {
        ticket_medio: "ticketMedio",
        margem_lucro: "margemLucro",
        vendas_periodo: "valorVendas",
        inadimplencia: "inadimplencia",
        relacao_financeira: "relacaoFinanceira",
        produtos_mais_vendidos: "produtosMaisVendidos",
        maiores_clientes: "clientesTop",
      };

      if (cardId === "relacao_vendas") {
        return {
          "change-comparacao": this.onComparacaoVendas,
        };
      }

      if (periodoHandlers[cardId]) {
        return {
          "change-periodo": (payload) =>
            this.onPeriodoChange(periodoHandlers[cardId], payload),
        };
      }

      return {};
    },
    startDashboardEdit() {
      this.dashboardLayoutSnapshot = this.cloneDashboardLayout(
        this.dashboardLayout
      );
      this.dashboardEditing = true;
    },
    cancelDashboardEdit() {
      this.dashboardLayout = this.cloneDashboardLayout(
        this.dashboardLayoutSnapshot
      );
      this.dashboardEditing = false;
    },
    restoreDefaultDashboardLayout() {
      this.dashboardLayout = getDefaultDashboardLayout(
        this.visibleDashboardCards
      );
    },
    async saveDashboardLayout() {
      try {
        const { data } = await this.$http.post("/dashboard/layout", {
          layout: this.dashboardLayout,
        });
        const layout = data?.layout || this.dashboardLayout;

        this.dashboardLayout = normalizeDashboardLayout(
          layout,
          this.visibleDashboardCards
        );
        this.dashboardLayoutSnapshot = this.cloneDashboardLayout(
          this.dashboardLayout
        );
        this.dashboardEditing = false;

        if (this.currentUser) {
          this.currentUser.dashboard_layout = this.cloneDashboardLayout(
            this.dashboardLayout
          );
        }

        this.$toast?.success?.("Layout do dashboard salvo!");
      } catch (error) {
        this.$toast?.error?.("Não foi possível salvar o layout do dashboard.");
      }
    },
    resetFiltrosDefault() {
      const hoje = (() => {
        const d = new Date();
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
        return d.toISOString().slice(0, 10);
      })();
      this.filtros = { inicio_tm: hoje, fim_tm: hoje };
      this.tmPeriodo = null; // <-- volta a null no reset
      this.relacaoVendas = [];
      this.loadingGraficoVendas = false;
    },

    async fetchNovidadesDashboard() {
      try {
        const { data } = await this.$http.post("/novidades/dashboard");
        const pacote = data.data && data.data.id ? data.data : null;
        this.pacoteNovidades = pacote;

        if (this.pacoteNovidades && this.pacoteNovidades.exibir_modal) {
          this.$nextTick(() => {
            this.$bvModal.show("modal-novidades-dashboard");
            this.modalNovidadesAberto = true;
          });
        }
      } catch (_) {
        // silencia erros — card simplesmente não aparece
      }
    },

    abrirModalNovidades(pacote) {
      this.pacoteNovidades = pacote;
      this.$bvModal.show("modal-novidades-dashboard");
      this.modalNovidadesAberto = true;
    },

    onNovidadeLida() {
      this.pacoteNovidades = null;
      this.modalNovidadesAberto = false;
    },

    async fetchDashboard() {
      try {
        this.loadingTotais = true;
        this.loadingTicketMedio = true;
        this.loadingMargemLucro = true;
        this.loadingValorVendas = true;
        this.loadingInadimplencia = true;
        this.loadingRelacaoFinanceira = true;
        this.loadingAniversariantes = true;
        this.loadingTopProdutos = true;
        this.loadingMaioresClientes = true;
        this.loadingGraficoVendas = true;
        this.loadingMeta = true;
        this.loadingCaixaAberto = true;
        this.loadingEstoqueCritico = true;
        const hoje = this.filtros.inicio_tm; // já é hoje

        const payload = {
          inicio_inadimplencia: hoje,
          fim_inadimplencia: hoje,
          inicio_relacao_fina: this.semana.inicio,
          fim_relacao_fina: this.semana.fim,
          inicio_tm: hoje,
          fim_tm: hoje,
          inicio_margem: hoje,
          fim_margem: hoje,
          inicio_vendas: hoje,
          fim_vendas: hoje,
          inicio_produtos: hoje,
          fim_produtos: hoje,
          inicio_cliente: hoje,
          fim_cliente: hoje,
          mode: "ano",
          periodo_a: null,
          periodo_b: null,
        };

        if (this.useCustomDashboard) {
          payload.cards = this.visibleDashboardCardIds;

          if (payload.cards.length === 0) {
            return;
          }
        }

        const { data } = await this.$http.post(
          "/dashboard/totais-dashboard",
          payload
        );

        if (data.totais_cadastros) {
          this.totais_cadastros = data.totais_cadastros;
          this.loadingTotais = false;
        }
        if (data.totais_financeiros) {
          this.totais_financeiros = data.totais_financeiros;
        }
        if (data.ticketMedio) {
          this.ticketMedio = data.ticketMedio;
          this.loadingTicketMedio = false;
        }
        if (this.hasMargemLucroData(data)) {
          this.margemLucro = this.normalizeMargemLucro(data);
          this.loadingMargemLucro = false;
        }
        if (data.valorVendas) {
          this.valorVendas = data.valorVendas;
          this.loadingValorVendas = false;
        }
        if (data.inadimplencia) {
          this.inadimplencia = data.inadimplencia;
          this.loadingInadimplencia = false;
        }
        if (data.relacaoFinanceira) {
          this.relacaoFinanceira = data.relacaoFinanceira;
          this.loadingRelacaoFinanceira = false;
        }
        if (data.aniversariantes) {
          this.aniversariantes = data.aniversariantes;
          this.loadingAniversariantes = false;
        }
        if (data.produtosMaisVendidos) {
          this.produtosMaisVendidos = data.produtosMaisVendidos;
          this.loadingTopProdutos = false;
        }
        if (data.clientesTop) {
          this.clientesTop = data.clientesTop;
          this.loadingMaioresClientes = false;
        }
        if (data.relacaoVendas) {
          this.relacaoVendas = data.relacaoVendas;
          this.loadingGraficoVendas = false;
        }
        if (data.meta) {
          this.metaMensal = data.meta;
          this.loadingMeta = false;
        }
        if (data.caixaAberto) {
          this.caixaAberto = data.caixaAberto;
          this.loadingCaixaAberto = false;
        }
        if (data.estoqueCritico) {
          this.estoqueCritico = data.estoqueCritico;
          this.loadingEstoqueCritico = false;
        }
      } finally {
        this.loadingTotais = false;
        this.loadingTicketMedio = false;
        this.loadingMargemLucro = false;
        this.loadingValorVendas = false;
        this.loadingInadimplencia = false;
        this.loadingRelacaoFinanceira = false;
        this.loadingAniversariantes = false;
        this.loadingTopProdutos = false;
        this.loadingMaioresClientes = false;
        this.loadingGraficoVendas = false;
        this.loadingMeta = false;
        this.loadingCaixaAberto = false;
        this.loadingEstoqueCritico = false;
      }
    },

    async fetchIndicadorOnly(tipo, inicio, fim) {
      const cfg = this.INDICADORES[tipo];
      if (!cfg) {
        return;
      }

      try {
        this[cfg.loadingKey] = true;

        const payload = {
          [cfg.inicioKey]: inicio,
          [cfg.fimKey]: fim,
          [cfg.onlyKey]: true,
        };

        if (tipo === "margemLucro") {
          payload.inicio_vendas = inicio;
          payload.fim_vendas = fim;
          payload.only_vendas = true;
        }

        const { data } = await this.$http.post(
          "/dashboard/totais-dashboard",
          payload
        );

        // Atualiza estado se veio a chave esperada
        if (tipo === "margemLucro" && this.hasMargemLucroData(data)) {
          let margemData = data;

          if (
            !this.hasLucroData(margemData) &&
            !this.hasValorVendasData(margemData)
          ) {
            margemData = {
              ...margemData,
              ...(await this.fetchValorVendasPeriodo(inicio, fim)),
            };
          }

          this[cfg.stateKey] = this.normalizeMargemLucro(margemData);
        } else if (Object.prototype.hasOwnProperty.call(data, cfg.stateKey)) {
          this[cfg.stateKey] = data[cfg.stateKey];
        }
      } catch (e) {
        this.$toast?.danger?.(
          "Houve algum problema, chame um consultor da Nuts!"
        );
      } finally {
        this[cfg.loadingKey] = false;
      }
    },

    // Handler único para mudança de período
    onPeriodoChange(tipo, { inicio, fim }) {
      const cfg = this.INDICADORES[tipo];
      if (!cfg) return;

      // Atualiza filtros e período correspondente
      this.filtros = {
        ...this.filtros,
        [cfg.inicioKey]: inicio,
        [cfg.fimKey]: fim,
      };
      this[cfg.periodoKey] = { inicio, fim };

      // Dispara a busca do indicador
      this.fetchIndicadorOnly(tipo, inicio, fim);
    },
    hasMargemLucroData(data = {}) {
      const margem = data.margemLucro;
      const margemKeys = [
        "margemLucro",
        "margem_lucro",
        "margem",
        "margemPercent",
        "margemPercentual",
        "percentualLucro",
        "percentual_lucro",
      ];
      const lucroKeys = [
        "lucro",
        "lucroTotal",
        "lucro_total",
        "valorLucro",
        "valor_lucro",
        "totalLucro",
        "total_lucro",
        "lucroReais",
        "lucro_reais",
      ];

      return (
        [...margemKeys, ...lucroKeys].some((key) =>
          Object.prototype.hasOwnProperty.call(data, key)
        ) || Boolean(margem && typeof margem === "object")
      );
    },
    hasLucroData(data = {}) {
      const margem = data.margemLucro;
      const margemSource = margem && typeof margem === "object" ? margem : {};
      const lucroKeys = [
        "lucro",
        "lucroTotal",
        "lucro_total",
        "valorLucro",
        "valor_lucro",
        "totalLucro",
        "total_lucro",
        "lucroReais",
        "lucro_reais",
      ];

      return lucroKeys.some(
        (key) =>
          Object.prototype.hasOwnProperty.call(data, key) ||
          Object.prototype.hasOwnProperty.call(margemSource, key)
      );
    },
    hasValorVendasData(data = {}) {
      const vendasKeys = [
        "valorVendas",
        "valor_vendas",
        "totalVendas",
        "total_vendas",
        "vendas",
        "receita",
        "receitaTotal",
        "receita_total",
      ];

      return vendasKeys.some((key) =>
        Object.prototype.hasOwnProperty.call(data, key)
      );
    },
    normalizeMargemLucro(data = {}) {
      const margem = data.margemLucro;
      const margemSource = margem && typeof margem === "object" ? margem : data;
      const margemPercent =
        margemSource.margemPercent ??
        margemSource.margemPercentual ??
        margemSource.percentualLucro ??
        margemSource.percentual_lucro ??
        margemSource.margemLucro ??
        margemSource.margem_lucro ??
        margemSource.margem ??
        (typeof margem !== "object" ? margem : 0);
      const lucro =
        margemSource.lucro ??
        margemSource.lucroTotal ??
        margemSource.lucro_total ??
        margemSource.valorLucro ??
        margemSource.valor_lucro ??
        margemSource.totalLucro ??
        margemSource.total_lucro ??
        margemSource.lucroReais ??
        margemSource.lucro_reais ??
        data.lucro ??
        data.lucroTotal ??
        data.lucro_total ??
        data.valorLucro ??
        data.valor_lucro ??
        data.totalLucro ??
        data.total_lucro ??
        data.lucroReais ??
        data.lucro_reais ??
        this.calculateLucroFromMargem(data, margemPercent);

      return {
        margemPercent,
        lucro,
      };
    },
    async fetchValorVendasPeriodo(inicio, fim) {
      const { data } = await this.$http.post("/dashboard/totais-dashboard", {
        inicio_vendas: inicio,
        fim_vendas: fim,
        only_vendas: true,
      });

      return data || {};
    },
    calculateLucroFromMargem(data = {}, margemPercent = 0) {
      const valorVendas =
        data.valorVendas ??
        data.valor_vendas ??
        data.totalVendas ??
        data.total_vendas ??
        data.vendas ??
        data.receita ??
        data.receitaTotal ??
        data.receita_total;
      const margemNumber = this.toDashboardNumber(margemPercent);
      const vendasNumber = this.toDashboardNumber(valorVendas);

      if (!Number.isFinite(margemNumber) || !Number.isFinite(vendasNumber)) {
        return 0;
      }

      return (vendasNumber * margemNumber) / 100;
    },
    toDashboardNumber(value) {
      if (value === null || value === undefined || value === "") return 0;

      if (typeof value === "string") {
        const normalized = value.includes(",")
          ? value.replace(/\./g, "").replace(",", ".")
          : value;
        const n = Number(normalized);
        return Number.isFinite(n) ? n : 0;
      }

      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    },
    async onComparacaoVendas({ modeId, a, b }) {
      this.loadingGraficoVendas = true;
      try {
        const { data } = await this.$http.post("/dashboard/totais-dashboard", {
          mode: modeId,
          only_comparativo_vendas: true,
        });
        this.relacaoVendas = data.relacaoVendas;
        this.loadingGraficoVendas = false;
      } catch (e) {
        this.$toast?.danger(
          "Não foi possível carregar o comparativo de vendas."
        );
      } finally {
        this.loadingGraficoVendas = false;
      }
    },
  },
};
</script>

<style>
.dash-widget .card-body {
  padding: 0;
}
</style>

<style scoped>
.custom-dashboard-grid {
  min-height: 240px;
}
.dashboard-grid-card {
  height: 100%;
  position: relative;
}
.dashboard-grid-card > .dash-widget {
  display: block;
  height: 100%;
}
.dashboard-grid-card-editing {
  cursor: move;
  outline: 2px dashed rgba(246, 78, 96, 0.35);
  outline-offset: 4px;
}
.dashboard-grid-card-editing > .dash-widget {
  pointer-events: none;
  user-select: none;
}
.dashboard-drag-handle {
  background: #f64e60;
  border-radius: 6px;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  padding: 0.35rem 0.5rem;
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  z-index: 5;
}
.dashboard-edit-toolbar {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
.dashboard-edit-toolbar-mobile {
  padding-right: 1rem;
}
.dashboard-edit-icon {
  align-items: center;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  padding: 0;
  width: 34px;
}
.dashboard-empty-custom {
  background: #ffffff;
  border: 1px solid #ebedf3;
  border-radius: 8px;
  color: #7e8299;
  font-weight: 600;
  margin-bottom: 2rem;
  padding: 2rem;
  text-align: center;
}
.vue-grid-item.vue-grid-placeholder {
  background: rgba(246, 78, 96, 0.18);
  border-radius: 8px;
}
@media (min-width: 1840px) {
  .d-xxxl-block {
    display: block !important;
  }
  .d-xxxl-none {
    display: none !important;
  }
  .col-xxxl-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-xxxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
